/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/* eslint-disable */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

// import { AnalyticsApi } from '@asicsdigital/oneasics-blocks';
// import { Box, useDisclosure, useStyleConfig } from '@chakra-ui/react';
// import { SkipNavLink, SkipNavContent } from '@chakra-ui/skip-nav';
import { nanoid } from '@reduxjs/toolkit';
import PropTypes from 'prop-types';
// import { getAssetUrl } from 'pwa-kit-react-sdk/ssr/universal/utils';
import { defineMessages, IntlProvider } from 'react-intl';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useTracking } from 'react-tracking';

// import useCustomer from '../../commerce-api/hooks/useCustomer';
// import useShopper from '../../commerce-api/hooks/useShopper';
// import { HOME_HREF } from '../../constants';
// import { CategoriesContext } from '../../contexts';
import { logTealiumAnalytics } from '../../services/AnalyticsApi';
import { persistor, store } from '../../store/store';

// import './styles.css';



// Chakra

// Contexts

// Local Project Components
import { getLocaleConfig } from '../../utils/locale';
// import { homeUrlBuilder } from '../../utils/url';
// import { watchOnlineStatus, flatten } from '../../utils/utils';
// import DrawerMenu from '../drawer-menu';
// import Footer from "../footer"
// import Header from "../header"
// import OfflineBanner from "../offline-banner"
// import OfflineBoundary from "../offline-boundary"
// import ScrollToTop from "../scroll-to-top"
// import CheckoutHeader from '../../pages/checkout/partials/checkout-header';
// import CheckoutFooter from '../../pages/checkout/partials/checkout-footer';
// import ListMenu from '../list-menu';
// import { HideOnDesktop, HideOnMobile } from '../responsive';

// Hooks
// import { AuthModal, useAuthModal } from '../../hooks/use-auth-modal';

// Localization

// Others
import Seo from '../seo';
import useWishlist from '../../hooks/use-wishlist';

const DEFAULT_NAV_DEPTH = 3;
const DEFAULT_ROOT_CATEGORY = 'root';

/**
 *  Default messages for the supported locales.
 *  NOTE: Because the messages are statically analyzed, we have to maintain the list of locales asynchronously
 *  to those in the package.json.
 *  `locale` parameter format for OCAPI and Commerce API: <language code>-<country code>
 *  https://documentation.b2c.commercecloud.salesforce.com/DOC1/topic/com.demandware.dochelp/OCAPI/current/usage/Localization.html
 *  */
// export const defaultLocaleMessages = defineMessages({
//     'en-US': { defaultMessage: 'English' },
//     'en-GB': { defaultMessage: 'English (United Kingdom)' },
//     'fr-FR': { defaultMessage: 'French (France)' },
//     'it-IT': { defaultMessage: 'Italian (Italy)' },
//     'zh-CN': { defaultMessage: 'Chinese (China)' },
//     'ja-JP': { defaultMessage: 'Japanese (Japan)' },
// });

const App = (props) => {
    const [sessionId] = useState(nanoid());
    const { Track } = useTracking({
        gaEventCategory: 'shoe finder 2.0',
        sf2_experience_id: sessionId,
    }, {
        dispatch: (data) => logTealiumAnalytics(data),
    });

    const { children, targetLocale, defaultLocale, messages, categories: allCategories = {} } = props;

    const history = useHistory();
    const location = useLocation();
    // const authModal = useAuthModal();
    // const customer = useCustomer();
    const [isOnline, setIsOnline] = useState(true);
    const [categories, setCategories] = useState(allCategories);
    // const styles = useStyleConfig('App');

    // const { isOpen, onOpen, onClose } = useDisclosure();

    // Used to conditionally render header/footer for checkout page
    const isCheckout = /\/checkout$/.test(location?.pathname);

    // Set up customer and basket
    // useShopper();

    // const wishlist = useWishlist();
    // useEffect(() => {
    //     if (!customer.isInitialized) {
    //         return;
    //     }
    //     if (customer.isRegistered) {
    //         wishlist.init();
    //     }
    //     if (customer.isGuest) {
    //         wishlist.reset();
    //     }
    // }, [customer.authType]);

    // useEffect(() => {
    //     // Listen for online status changes.
    //     watchOnlineStatus((isOnline) => {
    //         setIsOnline(isOnline);
    //     });
    // }, []);

    useEffect(() => {
        // Lets automatically close the mobile navigation when the
        // location path is changed.
        // onClose();
    }, [location]);

    const onLogoClick = () => {
        // Goto the home page.
        // history.push(homeUrlBuilder(HOME_HREF, targetLocale));

        // Close the drawer.
        // onClose();
    };

    const onCartClick = () => {
        // Goto the home page.
        history.push(`/${targetLocale}/cart`);

        // Close the drawer.
        // onClose();
    };

    const onAccountClick = () => {
        // Link to account page for registered customer, open auth modal otherwise
        // if (customer.isRegistered) {
            // history.push(`/${targetLocale}/account`);
        // } else {
            // if they already are at the login page, do not show login modal
            // if (new RegExp(`^/${targetLocale}/login$`).test(location.pathname)) return;
            // authModal.onOpen();
        // }
    };

    const onWishlistClick = () => {
        history.push(`/${targetLocale}/account/wishlist`);
    };

    const a = typeof window === 'undefined' ? (
        <Track>
            <Provider store={store}>
                <IntlProvider locale="en-US">
                    <div className="sf-app">
                    {children}
                    </div>
                </IntlProvider>
            </Provider>
        </Track>
    ) : (
        <Track>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <IntlProvider locale="en-US">
                        <div className="sf-app">
                        {children}
                        </div>
                    </IntlProvider>
                </PersistGate>
            </Provider>
        </Track>
    );

    return a;

    // return (
    //     <Provider store={store}>
    //         <IntlProvider locale="en-US">
    //             <div className="sf-app">
    //                 {children}
    //             </div>
    //         </IntlProvider>
    //     </Provider>
    // );
};

App.shouldGetProps = () => {
    // In this case, we only want to fetch data for the app once, on the server.
    return typeof window === 'undefined';
};

App.getProps = async ({ api }) => {
    const localeConfig = await getLocaleConfig({
        getUserPreferredLocales: () => {
            // CONFIG: This function should return an array of preferred locales. They can be
            // derived from various sources. Below are some examples of those:
            //
            // - client side: window.navigator.languages
            // - the page URL they're on (example.com/en-GB/home)
            // - cookie (if their previous preference is saved there)
            //
            // If this function returns an empty array (e.g. there isn't locale in the page url),
            // then the app would use the default locale as the fallback.

            // NOTE: Your implementation may differ, this is jsut what we did.
            //
            // Since the CommerceAPI client already has the current `locale` set,
            // we can use it's value to load the correct messages for the application.
            // Take a look at the `app/components/_app-config` component on how the
            // preferred locale was derived.
            const { locale } = api.getConfig();

            return [locale];
        },
    });

    // Login as `guest` to get session.
    await api.auth.login();

    // Get the root category, this will be used for things like the navigation.
    const rootCategory = await api.shopperProducts.getCategory({
        parameters: {
            id: DEFAULT_ROOT_CATEGORY,
            levels: DEFAULT_NAV_DEPTH,
            locale: localeConfig.app.targetLocale,
        },
    });

    if (rootCategory.isError) {
        const message =
            rootCategory.title === 'Unsupported Locale'
                ? `
                
🚫 This page isn’t working.
It looks like the locale ‘${rootCategory.locale}’ hasn’t been set up, yet. 
You can either follow this doc, https://sfdc.co/B4Z1m to enable it in business manager or define a different locale with the instructions for Localization in the README file.
`
                : rootCategory.detail;
        throw new Error(message);
    }

    // Flatten the root so we can easily access all the categories throughout
    // the application.
    // const categories = flatten(rootCategory, 'categories');

    return {
        targetLocale: localeConfig.app.targetLocale,
        defaultLocale: localeConfig.app.defaultLocale,
        messages: localeConfig.messages,
        // categories,
    };
};

App.propTypes = {
    children: PropTypes.node,
    targetLocale: PropTypes.string,
    defaultLocale: PropTypes.string,
    location: PropTypes.object,
    messages: PropTypes.object,
    categories: PropTypes.object,
};

export default App;

// persistor.subscribe(() => {
//     /* Hydrate React components when persistor has synced with redux store */
//     const { bootstrapped } = persistor.getState();

//     if (bootstrapped && typeof document !== 'undefined') {
//         console.log('asdfasfafasfafadfafd');
//         console.log(bootstrapped);
//         // ReactDOM.hydrate(<App/>, document.getElementsByClassName("react-target")[0]);
//     }
// });
